import { storeToRefs } from "pinia";
import { useAuthorisationStore } from "./authorisation.store";

import { SUPER_ADMIN, type Action, type Resource } from "./authorisation.types";

const useAuthorisation = () => {
  const store = useAuthorisationStore();
  const { policy } = storeToRefs(store);

  function hasPermission(action: Action, resource: Resource): boolean {
    if (!policy.value) {
      return false;
    }

    if (policy.value.name === SUPER_ADMIN) {
      return true;
    }

    return (
      policy.value.permissions
        ?.find((permission) => permission.feature === resource)
        ?.actions.includes(action) ?? false
    );
  }

  return { policy, hasPermission };
};

const useAuthorisationStrategy = () => {
  async function authoriseOnSignIn() {
    const { fetchPolicy } = useAuthorisationStore();

    try {
      await fetchPolicy();
    } catch {
      throw new Error("authoriseOnSignIn error: While fetching policy");
    }
  }

  function clearAuthorisationCache() {
    const { setPolicy } = useAuthorisationStore();

    setPolicy(null);
  }

  return {
    authoriseOnSignIn,
    clearAuthorisationCache,
  };
};

export { useAuthorisation, useAuthorisationStrategy };
